export default __webpack_public_path__ + "media/images/affaire_etape-terminee-7c3eb22a954c9698c6b201651c833965.png";